module.exports = __webpack_public_path__ + "img/img54.a9263934.svg";